import clsx from "clsx";
import React, { useEffect } from "react";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import OcrHeader from "./OcrHeader";
import { TYPE } from "../../constant";
import { useAppOcrOnOff, useUserInfo } from "../../hooks";
import { func_animation } from "../../utils/utilityEtc";
import useAmplitude from "../../hooks/useAmplitude";

const ITEMS = () => {
  const { t, i18n } = useTranslation();
  return [
    <div className="slide_wrap">
      <div className="slide_sheet">
        <div className="tit">
          <div className="num">
            <img src="../static/images/icon/ic_ocr_num_1.svg" alt="" />
          </div>
          <div className="txt">{t("LC_09_05.msg002")}</div>
        </div>
        <div className="cont box_type1">
          <article>
            <p>{t("LC_09_05.msg003")}</p>
          </article>
          <article className="box2">
            <p dangerouslySetInnerHTML={{__html: t("LC_09_05.msg004")}} />
          </article>
        </div>
      </div>
    </div>,
    <div className="slide_wrap">
      <div className="slide_sheet">
        <div className="tit">
          <div className="num">
            <img src="../static/images/icon/ic_ocr_num_2.svg" alt="" />
          </div>
          <div className="txt">
            {t("LC_09_05.msg005")}
          </div>
        </div>
        <div className="cont">
          <div className="img_box">
            <div className="box_inner">
              <div className="anim-wrap" id="img_ocr_manual_2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    <div className="slide_wrap">
      <div className="slide_sheet">
        <div className="tit">
          <div className="num">
            <img src="../static/images/icon/ic_ocr_num_3.svg" alt="" />
          </div>
          <div className="txt">
            {t("LC_09_05.msg006")}
          </div>
        </div>
        <div className="cont">
          <div className="img_box">
            <div className="box_inner">
              <div className="anim-wrap" id="img_ocr_manual_3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    <div className="slide_wrap">
      <div className="slide_sheet">
        <div className="tit">
          <div className="num">
            <img src="../static/images/icon/ic_ocr_num_4.svg" alt="" />
          </div>
          <div className="txt">{t("LC_09_05.msg007")}</div>
        </div>
        <div className="cont box_type2">
          <article className="box1">
            <p>{t("LC_09_05.msg008")}</p>
          </article>
          <article 
            className={clsx(
              "box2",
              i18n.language === 'en' ? 'en' : ''
            )}
          >
            <p>{t("LC_09_05.msg009")}</p>
          </article>
          <article className="box3">
            <p>{t("LC_09_05.msg010")}</p>
          </article>
          <article className="box4">
            <p>{t("LC_09_05.msg011")}</p>
          </article>
        </div>
      </div>
    </div>
  ];
}

function OcrUsage() {
  const { appOcrOnOff } = useAppOcrOnOff();
  const { setAmplitudeLog } = useAmplitude();
  const { info } = useUserInfo();
  const { t } = useTranslation();
  useEffect(() => {
    // 네이티브 뒤로가기 on off
    appOcrOnOff('Y');
    setAmplitudeLog({ eventCategory: 'ocr', eventName: 'ocr안내 조회' });
  }, []);

  const settings = { dots: true, };
  const deviceType = useSelector(state => state.deviceInfo.type);
  
  useEffect(() => {;
    func_animation('img_ocr_manual_2', 'img_ocr_manual_2', true);
    func_animation('img_ocr_manual_3', 'img_ocr_manual_3', true, 2000);
  });

  return (
    <div className={clsx(
      "layout-def bg_gray ocr_slide header_absolute",
      info.className,
    )}>
      <OcrHeader
        title={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? t("LC_09_05.msg001") : 'OCR 학습 사용법'}
        headerColorClassName={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'bg_sky header_white_font' : ''}
      />
      <div className="container">
        <div className="inner">
          <div className="slide_cont">
            {
              deviceType === TYPE.DEVICE.PHONE
                ? (
                  <div className="slick_slider js_slick">
                    {ITEMS().map((item, index) => <React.Fragment key={index}>{item}</React.Fragment>) }
                  </div>
                )
                : (
                  <Slider className="slick_slider js_slick" {...settings}>
                    {ITEMS().map((item, index) => <React.Fragment key={index}>{item}</React.Fragment>) }
                  </Slider>      
                )
            }
          </div>
        </div>
      </div>
    </div>
  );
};


export default OcrUsage;
